import { ReferenceArrayInput, AutocompleteArrayInput, AutocompleteInput, minValue, BooleanInput, NumberInput, ReferenceInput, required, SelectInput, SimpleForm, useRedirect, useDataProvider } from "react-admin";
import { CloseButton, DefaultToolbar, Field, Legend, Row } from "../common/components";
import { unitTime } from "../common/components/utils/choice";
import { useSimpleController } from "../common/components/utils/useSimpleController";
import { selectStage } from "../services/project/actions";
import { useForm } from 'react-final-form';
import { filterObject, filterValue } from "../common/components/utils/fn";
import { useEffect, useState } from "react";
import { getOne } from "../services/common/common";

const Subproject = () => {
    const form = useForm();
    const values = form.getState().values;
    const filter = {
        _and: filterValue([
            filterObject("status._eq", "enabled"),
            filterObject("id._neq", values.projectId)
        ])
    };
    return <>{
        values.isSubproject && <ReferenceInput source="subprojectId" reference="project" filter={filter} validate={[required()]}>
            <AutocompleteInput />
        </ReferenceInput>
    }</>
};

const Team = ({ displayMutlipleTeam }) => {
    const form = useForm();
    const values = form.getState().values;
    return <>
        {
            displayMutlipleTeam && values.isMultipleTeam && <ReferenceArrayInput fullWidth source="assignIds" reference="team" validate={[required()]}>
                <AutocompleteArrayInput />
            </ReferenceArrayInput>
        }
        {
            (!displayMutlipleTeam || !values.isMultipleTeam) && <ReferenceInput source="assignId" reference="team" validate={[required()]}>
                <AutocompleteInput />
            </ReferenceInput>
        }
    </>
};

export const StageInfosForm = ({ projectId, stageId, projectRecord }) => {
    const [displayMutlipleTeam, setDisplayMultipleTeam] = useState(false);
    const dataProvider = useDataProvider();
    const redirect = useRedirect();
    const filter = { projectId, stageId };
    const context = useSimpleController({ resource: "stage_infos", filter, filterRecharge: [projectId, stageId] });
    useEffect(() => {
        getOne(dataProvider, "stage", stageId).then(async (stage) => {
            let displayMutlipleTeam = true;
            if (!stage.isStarting && (stage.incoming.length === 1 || stage.incomingError.length === 1)) {
                if (stage.incoming.length === 1) {
                    await getOne(dataProvider, "stage", stage.incoming[0]).then((stagePrevious) => {
                        if (stagePrevious.outgoing.length !== 1) {
                            displayMutlipleTeam = false;
                        }
                    })
                }
                if (stage.incomingError.length === 1) {
                    await getOne(dataProvider, "stage", stage.incomingError[0]).then((stagePrevious) => {
                        if (stagePrevious.outgoingError.length !== 1) {
                            displayMutlipleTeam = false;
                        }
                    })
                }
            } else {
                displayMutlipleTeam = false;
            }
            setDisplayMultipleTeam(displayMutlipleTeam);
        });
    }, [stageId, dataProvider]);
    return <SimpleForm {...context} toolbar={<DefaultToolbar hasDelete={false} hasList={false} />} style={{ flex: 0.4 }} className="nopadding" initialValues={{ projectId, stageId, isSubproject: false, isMultipleTeam: false }}>
        <Row className="stayFlex">
            <Legend />
            <CloseButton onClick={() => { selectStage(redirect); }} />
        </Row>
        <ReferenceInput source="stageId" reference="stage">
            <SelectInput disabled />
        </ReferenceInput>
        {displayMutlipleTeam && <BooleanInput source="isMultipleTeam" />}
        <Team displayMutlipleTeam={displayMutlipleTeam} />
        <BooleanInput source="isSubproject" />
        <Subproject />
        <Legend label="resources.project.stages.quantity" variant="h4" className="nomargin" />
        <Row>
            <NumberInput source="quantity" validate={[required(), minValue(1)]} />
            <Field className="alignText" value={projectRecord && projectRecord.unitMeasure} />
        </Row>
        <Legend label="resources.project.stages.duration" variant="h4" className="nomargin" />
        <Row>
            <NumberInput source="duration" validate={[required(), minValue(1)]} />
            <SelectInput source="unitTime" choices={unitTime} validate={[required()]} />
        </Row>
    </SimpleForm>
};